import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
    {
    path: '/',
    name: '首页',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // 懒加载
    component: () => import(/* webpackChunkName: "about" */ '../views/layout'),
    redirect:'/home',
       children:[
      {
        path: '/home',
        name: '首页管理',
        component: () => import('../views/home/index')
      },
       {
        path: '/user',
        name: '用户管理',
        component: () => import('../views/user/index')
      },
        {
        path: '/order',
        name: '音乐管理',
        component: () => import('../views/order/index')
      },
      {
        path: '/modifyPassword',
        name: '修改密码',
        component: () => import('../views/modifyPassword/index')
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // 懒加载
    component: () => import(/* webpackChunkName: "about" */ '../views/login')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
